(() => {
  if (customElements.get('castle-photo-reveals')) return;
  class CastlePhotoReveals extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.seen = new WeakSet();
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.observer.unobserve(entry.target);
          if (this.motion.matches) continue;
          const animation = entry.target.animate([{ opacity: .65, transform: 'scale(1.025)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 850, easing: 'cubic-bezier(.2,.65,.3,1)' });
          this.animations.add(animation);
          animation.finished.then(() => this.animations.delete(animation)).catch(() => {});
        }
      }, { threshold: .15 });
      this.scan = () => {
        for (const image of document.querySelectorAll('.castle-gate-department-media img,.castle-category-card__image,.castle-featured-product__image')) {
          if (this.seen.has(image)) continue;
          this.seen.add(image);
          this.observer.observe(image);
        }
      };
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.animations.forEach(animation => animation.cancel());
      }, { signal });
      document.addEventListener('shopify:section:load', this.scan, { signal });
      this.scan();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
  }
  customElements.define('castle-photo-reveals', CastlePhotoReveals);
})();
